import * as React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import ProgressiveImage from "react-progressive-bg-image"
import { SimilarListingsComponent } from "src/generated/graphql"
import theme from "src/theme"
import Column, { BoxProps as ColumnProps } from "src/components/column/column.component"
import Box from "../box"
import Text from "../text"
import Row from "../row"
import { DEFAULT_SPACE_PICTURE } from "src/config/constants"

const ListingItems = styled(Row as any)`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

const ListingItem = styled(Column as any)`
  cursor: pointer;
  width: ${props => props.width};
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 64px;
  &:nth-child(odd) {
    padding-left: 0;
  }
  &:nth-child(even) {
    padding-right: 0;
  }
  @media (min-width: ${theme.breakpoints[0]}) {
    padding-left: 0;
    padding-right: 24px;
    &:nth-child(odd) {
      padding-left: 0;
    }
    &:nth-child(even) {
      padding-right: 24px;
    }
  }
`

const ListingItemImage = styled(ProgressiveImage)`
  display:flex;
  flex-direction:column;
  width:100%;
  height:112px;
  border-radius: 4px;
  background-color: #d8d8d8;
  background-size:cover;
  background-position:center;
  background-image:url('${props => props.src}');
  @media (min-width:${theme.breakpoints[0]}) {
    height:172px;
  }
`
const MoreListImage = styled(ProgressiveImage)`
  background-size:cover;
  background-position:center;
  background-image:url('${props => props.src}');
  height:100%;
  width:100%;
`

const SeeMoreListings = styled(Column as any)<ColumnProps & { src: string }>`
  align-items: center;
  width: ${props => props.width};
  height: 112px;
  max-width: 262px;
  margin-right: 0;
  cursor: pointer;
  @media (min-width: ${theme.breakpoints[0]}) {
    height: 172px;
    margin-right: 6px;
  }
  &:hover {
    > div:nth-of-type(2) {
      background-color: orange;
      background-color: rgba(0, 168, 87, 0.85);
    }
  }
`

const SeeMoreListingsOverlay = styled(Column as any)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 168, 87, 0.7);
  border-radius: 4px;
  z-index: 1;
  transition-duration: 0.2s;
  transition-property: background-color;
`

const SeeMoreListingsContent = styled(Column as any)`
  position: relative;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: 100%;
  z-index: 2;
`
const HeadingH2 = styled.h2`
  text-decoration: none;
  margin-bottom: 18px;
  color: rgb(60, 66, 64);
  font-size: 32px;
  font-weight: 600;
`

const TextWithEllipsis = styled(Text as any)`
  &:empty {
    display: none;
  }
`

interface Props {
  match: {
    params: {
      id: string
    }
  }
}
class SimilarListingsSection extends React.PureComponent<Props> {
  render() {
    const { match } = this.props
    return (
      <SimilarListingsComponent
        variables={{
          id: match.params.id
        }}
      >
        {({ error, data, loading }) => {
          if (error) {
            console.log({ error })
            return <div>Error...</div>
          }
          if (loading) return <div>loading...</div>

          if (!data) return <div>no data...</div>
          const { similarListings } = data
          return (
            <Box mb={[5]} flexDirection="column">
              <HeadingH2 fontSize={[5]} fontWeight={600} mb={[2]}>
                Similar Listings
              </HeadingH2>
              <ListingItems>
                {/* Row */}
                {similarListings && similarListings.length
                  ? similarListings.map((item, idx) => {
                      return (
                        item && (
                          <ListingItem
                            width={["50%", "33%", "25%", "25%"]}
                            key={`${idx}-${item.id}`}
                          >
                            <Link to={`/listing/${item.id}`}>
                              {/* Icon */}
                              <ListingItemImage
                                src={
                                  item.pictures && item.pictures[0] && item.pictures[0].url
                                    ? item.pictures[0].url
                                    : "/images/lofts-4.jpg"
                                }
                                transition="all 1s linear"
                                placeholder={DEFAULT_SPACE_PICTURE}
                              />
                              {/* Subtext */}
                              <Text
                                color={theme.colors.primary}
                                fontSize={[0, 1, 1]}
                                fontWeight={5}
                                mt={3}
                              >
                                {item.location && item.location.neighbourHood
                                  ? item.location.neighbourHood.name
                                  : "N/A"}
                              </Text>
                              {/* Title */}
                              <Text as="h3" fontSize={[2, 3, 3]} fontWeight={600} mt={2}>
                                {item.title}
                              </Text>
                              {/* Description */}
                              <TextWithEllipsis
                                fontSize={[1, 2, 2]}
                                fontWeight={2}
                                lineHeight={5}
                                mt={2}
                              >
                                {item.description.substring(0, 70)}
                                {item.description.length > 100 ? "..." : null}
                              </TextWithEllipsis>
                            </Link>
                          </ListingItem>
                        )
                      )
                    })
                  : null}
                <ListingItem width={["50%", "33%", "25%", "25%"]} key={`moar`}>
                  <SeeMoreListings>
                    <MoreListImage src="/images/lofts-4.jpg" placeholder={DEFAULT_SPACE_PICTURE}>
                      {/* Title */}
                      <SeeMoreListingsContent width={["100%"]}>
                        <Link to="/search?city=Toronto&one_bedroom=true">
                          <Text color={theme.colors.white} fontSize={[2, 3, 3]}>
                            See more listings
                          </Text>
                        </Link>
                        <Text
                          style={{
                            width: "98%"
                          }}
                          color={theme.colors.white}
                          fontSize={[1, 2, 2]}
                        >
                          We’ve made it easy to find your perfect place
                        </Text>
                      </SeeMoreListingsContent>
                      {/* Overlay */}
                      <SeeMoreListingsOverlay width={["100%"]} />
                    </MoreListImage>
                  </SeeMoreListings>
                </ListingItem>
              </ListingItems>
            </Box>
          )
        }}
      </SimilarListingsComponent>
    )
  }
}

export default SimilarListingsSection
